








































































































































































































import Vue from 'vue';
import _ from 'lodash';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Alert, NoticeClass, Dialog } from '@kasasa/fbase-components/lib';
import { TextBoxDatePicker } from '@kasasa/portal-components';
import { Product, ProductResource } from '@/api/product';
import { DateTool, ValidationTool } from '@/util';
import {
  QualRewardGroup,
} from '@/api/product/levelrewards';
import { InterestReward } from '@/api/product/levelrewards/rewards';
import { LinkedAccountQualifier } from '@/api/product/levelrewards/qualifiers';
import { ProductMapping } from '@/api/productmapping';
import { ConfigVersion, ConfigVersionDateRange } from '@/api/configversion';

@Component({
  computed: mapState(['fiId', 'allConfigVersions', 'configVersion']),
  components: {
    TextBoxDatePicker,
  },
})
export default class ProductSettings extends Vue {
  fiId!: string;

  allConfigVersions!: ConfigVersion[];

  configVersion!: ConfigVersion;

  @Prop() product!: Product;

  @Prop({ default: () => [] }) versionedProducts!: Product[];

  @Prop({ default: false }) isEditable!: boolean;

  @Prop({ default: false }) isDirty!: boolean;

  @Prop({ default: () => [] }) unassignedProductMappings!: ProductMapping[];

  @Prop({ default: false }) loading!: boolean;

  workingProduct:Product = ProductResource.createEmptyProduct();

  @Inject('ProductResource')
  productResource!: ProductResource;

  configVersionDateRange: ConfigVersionDateRange | null = null;

  productMappings:ProductMapping[] = [];

  isFormValid: boolean = false;

  isDesignDateValid: {isValid: boolean, message?: string|null} = { isValid: true, message: 'default' };

  saving: boolean = false;

  deleting: boolean = false;

  concatenatedProductCodes:string = '';

  initializingForm: boolean = true;

  requiredRule:Array<any> = [(value: any) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.setupConfigDateRange();
    this.onProductChange();
    this.setupProductMappings();
  }

  @Watch('product')
  onProductChange() {
    Object.assign(this.workingProduct, this.product);
    this.onDesignStartDateChange();
    this.initializingForm = true;
  }

  @Watch('unassignedProductMappings')
  setupProductMappings() {
    if (this.product && this.product.id && this.product.productMapping) {
      this.productMappings = [this.product.productMapping];
    } else {
      this.productMappings = this.unassignedProductMappings;
    }

    if (this.productMappings.length === 1) {
      // when there's only one product mapping to select, it will be preselected
      this.workingProduct.productMapping = this.productMappings[0];
    }
  }

  @Watch('workingProduct.productMapping')
  onNewProductMapping() {
    this.concatenatedProductCodes = '';
    if (this.workingProduct.productMapping) {
      for (let i = 0; i < this.workingProduct.productMapping.coreAccountProductTypes.length; i++) {
        this.concatenatedProductCodes += this.workingProduct.productMapping.coreAccountProductTypes[i].coreProductCode;

        if (i < this.workingProduct.productMapping.coreAccountProductTypes.length - 1) {
          this.concatenatedProductCodes += ', ';
        }
      }

      if (this.workingProduct.productMapping.productType === 'KASASA_TUNES' && !this.workingProduct.kasasaTunesConfiguration) {
        this.workingProduct.kasasaTunesConfiguration = {
          signUpBonusAmount: null,
          signUpBonusExpirationDays: null,
        };
      }
    }
  }

  @Watch('workingProduct.designStartDate')
  onDesignStartDateChange() {
    this.isDesignDateValid = this.getDesignStartDateValidationResults();
  }

  onSave() {
    this.saving = true;

    if (!this.workingProduct.serviceFee) {
      this.workingProduct.serviceFeeAmount = null;
    }

    this.productResource.save(this.fiId, this.workingProduct).then((savedProduct:Product) => {
      if (this.product) {
        Object.assign(this.product, savedProduct);
      }
      Object.assign(this.workingProduct, savedProduct);
      if (this.isSaverAndHasNoLevels()) {
        this.addLevelsToSaver();
        this.onSave();
      } else {
        this.saving = false;
        this.$emit('saved', savedProduct);
        this.workingProduct = savedProduct;
        this.showSuccessMessage('Product saved successfully.');
      }
    }).catch((error:any) => {
      this.saving = false;
  	  this.showError(error);
  	});
  }

  onReset() {
    this.$emit('reset');
  }

  @Watch('workingProduct', { deep: true })
  onWorkingProductChange() {
    if (this.initializingForm) {
      this.initializingForm = false;
    } else {
      const isDirty: boolean = _.isEqual(this.product, this.workingProduct) === false;
      this.$emit('dirtyForm', isDirty);
    }
  }

  onDelete() {
    const dialog = new Dialog('Confirm Deletion', 'Are you sure you want to delete this product?');
	    dialog.setAcceptLabel('OK')
	      .setDeclineLabel('Cancel');
	    this.$store.dispatch('notices/add', dialog).then((ok) => {
	      if (ok === 'accept') {
        this.deleteProduct();
      }
    });
  }

  setupConfigDateRange() {
    this.configVersionDateRange = ConfigVersionDateRange.ofVersion(this.configVersion, this.allConfigVersions);
    this.onDesignStartDateChange();
  }

  isSaverAndHasNoLevels(): boolean {
    return (this.workingProduct.productMapping.productType === 'KASASA_SAVER'
           || this.workingProduct.productMapping.productType === 'BUSINESS_REAL_SAVER')
           && this.workingProduct.qualRewardGroups.length === 0;
  }

  isStartDateChangeable(): boolean {
    const areOtherVersionOfProduct = this.versionedProducts && this.versionedProducts.length > 0;
    const isNewProduct = !this.product || !this.product.id;

    if (isNewProduct && !areOtherVersionOfProduct) {
      return false;
    }

    if (!this.configVersionDateRange) {
      return false;
    }

    return this.product.designStartDate !== DateTool.toIsoDateString(this.configVersionDateRange.startDate);
  }

  isStartDateInUse(startDate: string): boolean {
    if (!this.versionedProducts) {
      return false;
    }

    for (let i = 0; i < this.versionedProducts.length; i++) {
      const product = this.versionedProducts[i];
      if (product.designStartDate === startDate && product.id !== this.product.id) {
        return true;
      }
    }

    return false;
  }

  isDateInCoreVersionRange(startDate: string): boolean {
    if (this.configVersionDateRange) {
      return this.configVersionDateRange.isInConfigRange(startDate);
    }
    return true;
  }

  constructStartDateRangeErrorMessage(): string {
    if (!this.configVersionDateRange) {
      return 'Design start date must be in config version date range';
    }

    const startDate = DateTool.toFriendlyFormatFromDate(this.configVersionDateRange.startDate);
    const endDate = DateTool.toFriendlyFormatFromDate(this.configVersionDateRange.endDate);

    if (!this.configVersionDateRange.endDate) {
      return `Design Start Date must be on or after ${startDate}`;
    }

    return `Design Start Date must be between ${startDate} and ${endDate} (inclusive)`;
  }

  getDesignStartDateValidationResults() {
    const startDate: string = this.workingProduct.designStartDate;
    const tuple: {isValid: boolean, message?: string} = { isValid: false };

    if (!startDate) {
      tuple.message = 'Design Start Date is required';
      return tuple;
    }

    if (this.isStartDateInUse(startDate)) {
      tuple.message = `Design Start Date ${startDate} is already in use by a product design version`;
      return tuple;
    }

    if (!this.isDateInCoreVersionRange(startDate)) {
      tuple.message = this.constructStartDateRangeErrorMessage();
      return tuple;
    }

    tuple.isValid = true;
    return tuple;
  }

  addLevelsToSaver() {
    const qualRewardLevelZero:QualRewardGroup = ProductResource.createEmptyQualRewardGroup();

    const nonQualInterestReward:InterestReward = new InterestReward();
    nonQualInterestReward.tier1 = { apr: '0.05' };

    qualRewardLevelZero.rewards.push(nonQualInterestReward);

    const qualRewardLevelOne = ProductResource.createEmptyQualRewardGroup();
    qualRewardLevelOne.level = 1;

    const interestReward:InterestReward = new InterestReward();

    interestReward.tier1 = {
      apr: '1.51',
      cap: '50000.00',
    };

    interestReward.tier2 = {
      apr: '0.49',
    };

    qualRewardLevelOne.rewards.push(interestReward);

    const linkedAccountQualifier: LinkedAccountQualifier = new LinkedAccountQualifier();
    qualRewardLevelOne.qualifiers.push(linkedAccountQualifier);

    this.workingProduct.qualRewardGroups.push(qualRewardLevelZero);
    this.workingProduct.qualRewardGroups.push(qualRewardLevelOne);
  }

  deleteProduct() {
    this.deleting = true;
    this.productResource.remove(parseInt(this.fiId, 10), this.workingProduct.id!).then(() => {
      this.$emit('deleted');
    }).catch((error:any) => {
  	  this.showError(error);
  	}).finally(() => {
	    this.deleting = false;
  	 });
  }

  showError(error: any) {
	  console.error(error);
	  if (error.response && error.response.data && error.response.data.entity) {
	    this.showErrorMessage(error.response.data.entity);
	  } else if (error.response && error.response.data && Array.isArray(error.response.data.data) && error.response.data.data.length > 0) {
      this.showErrorMessage(error.response.data.data[0].message);
    } else {
	    this.showErrorMessage('An unexpected error occurred.');
	  }
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  showSuccessMessage(error: string) {
    const al = new Alert(error, NoticeClass.SUCCESS);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
